import React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import TeamHierarchy from "./hierarchy/TeamHierarchy";
import { TeamDtoWithBreadcrumb } from "../layout/subheader/SubHeaderDto";
import { MetricsState } from "../logging";
import EditTeamComponent from "./EditTeamComponent";
import EntityType from "../search/EntityType";
import { TeamOwnerDetailsDto } from "../common/model/teamownerdetails.dto";
import InfoLink from "../common/infoLink/InfoLink";
import helpPanelSlice, { DisplayHelpPanel } from "../help_panel/helpPanelSlice";
import { Container, Header } from "@amzn/awsui-components-react-v3";

interface TeamDetailsPageProps {
  team: TeamDtoWithBreadcrumb;
  ownerDetails?: TeamOwnerDetailsDto;
  metrics: MetricsState;
}

interface TeamDetailsPageDispatchProps {
  setHelpPanelContent: (payload: DisplayHelpPanel | undefined) => void;
  setHelpPanelOpenState: (payload: boolean | true) => void;
}

const TeamDetailsPage: React.FC<TeamDetailsPageProps &
  TeamDetailsPageDispatchProps> = ({
  setHelpPanelContent,
  setHelpPanelOpenState,
  team,
  ownerDetails,
  metrics,
}): JSX.Element => {
  const teamOwner = team.owner
    ? {
        title: "",
        urlId: team.owner ? team.owner.employeeId : undefined,
        type: EntityType.EMPLOYEE,
      }
    : undefined;
  const originalTeam = {
    ...team,
    owner: teamOwner,
  };
  return (
    <div style={{ display: "flex", gap: "20px" }}>
      <div style={{ width: "49%" }}>
        <Container
          disableContentPaddings
          header={
            <Header
              variant="h2"
              info={
                <InfoLink
                  onClick={() => {
                    setHelpPanelContent({
                      header: "Team hierarchy",
                      contentType: "teamDetails",
                      widenContent: true,
                    });
                    setHelpPanelOpenState(true);
                  }}
                />
              }
            >
              Team hierarchy
            </Header>
          }
        >
          <TeamHierarchy team={team} />
        </Container>
      </div>
      <div style={{ width: "49%" }}>
        <EditTeamComponent
          team={team}
          ownerDetails={ownerDetails}
          metrics={metrics}
          originalTeam={originalTeam}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = (
  dispatch: Dispatch
): TeamDetailsPageDispatchProps => ({
  setHelpPanelContent(helpPanelContent: DisplayHelpPanel | undefined) {
    dispatch(helpPanelSlice.actions.setHelpPanelContent(helpPanelContent));
  },
  setHelpPanelOpenState(helpPanelState: boolean) {
    dispatch(helpPanelSlice.actions.setHelpPanelOpenState(helpPanelState));
  },
});

export default connect(null, mapDispatchToProps)(TeamDetailsPage);
